import React, { useEffect, useState } from "react";

const ReviewCard = ({
  frontReview,
  frontName,
  backReview,
  backName,
  interval = 3500, // flip time
}) => {
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setFlipped((prev) => !prev);
    }, interval);

    return () => clearInterval(timer);
  }, [interval]);

  return (
    <div className="flip-card m-4">
      <div className={`flip-card-inner ${flipped ? "flipped" : ""}`}>

        {/* FRONT */}
        <div className="flip-card-front">
          <Stars />
          <p className="review-text">“{frontReview}”</p>
          <h4 className="name">— {frontName}</h4>
        </div>

        {/* BACK */}
        <div className="flip-card-back">
          <Stars />
          <p className="review-text">“{backReview}”</p>
          <h4 className="name">— {backName}</h4>
        </div>

      </div>
    </div>
  );
};

const Stars = () => (
  <div className="stars">★★★★★</div>
);

export default ReviewCard;
